import { isCarlineData } from '@oneaudi/feature-app-utils';
import type { OnegraphDataType } from '@oneaudi/feature-app-utils';

export function hasValidCaeContent(entry: OnegraphDataType[number]): boolean {
  if (!entry) return false;
  if (isCarlineData(entry)) {
    const { summary } = entry.carline.consumptionAndEmission;
    if (!summary) return false;
    return Boolean(summary.consumption || summary.emissionCO2);
  }
  const { carByCode } = entry as {
    carByCode?: {
      __typename?: string;
      technicalData?: {
        consumptionAndEmission?: {
          summary?: {
            consumptionsSummary?: Array<{
              values?: Array<{ formattedValue?: string | null }> | null;
            }> | null;
            emissionsCO2Summary?: Array<{
              values?: Array<{ formattedValue?: string | null }> | null;
            }> | null;
          };
        };
      };
    };
  };
  if (!carByCode || carByCode.__typename === 'AudiCodeError') return false;
  const summary = carByCode.technicalData?.consumptionAndEmission?.summary;
  const hasConsumption = summary?.consumptionsSummary?.some((c) =>
    c.values?.some((v) => Boolean(v.formattedValue)),
  );
  const hasEmission = summary?.emissionsCO2Summary?.some((e) =>
    e.values?.some((v) => Boolean(v.formattedValue)),
  );
  return Boolean(hasConsumption || hasEmission);
}
